import { Scene, Input, Math as MathPhaser } from "phaser";
import {
    backStaticAnimation, leftStaticAnimation, lightstickAnimation, mapHandler, reposeAnimation,
    rightStaticAnimation, turnStaticAnimation, upStaticAnimation, walkAnimation
} from '../../phaser/create';
import { walkHandler, directionHandler, randomDirection, setLastMovement } from '../../phaser/update';
import FullScreen from "../../phaser/components/fullScreen";
import PauseButton from "../../phaser/components/pauseButton";
import LightstickCounter from "../../phaser/components/lightstickCounter";
import ButtonPressed from "../../phaser/components/buttonPressed";
import SettingsButton from "../../phaser/components/settingsButton";
import HelpButton from "../../phaser/components/helpButton";
import Joystick from "../../phaser/components/joystick";

let cursors;
let walls;
let instructionsHandler = 0;

let characterSelected;
let objNames = {};
let enemy1;
let enemy2;
let timeoutDoor = {};
let footsteps;
let speedEnemy = 50;
let hearts = 2;
let totalHearts = 2;
let redHeartsObject = [];
let blackHeartsObject = [];
let gameSettings;
let hasLightstick = false;
let defaultSettings = 1;
let lastCoordenates = null;

const randomPointsEnemy = [
    { x: 3520, y: 1657 },
    { x: 3712, y: 478 },
    { x: 2488, y: 382 },
    { x: 2023, y: 695 },
    { x: 703, y: 785 },
]

export default class Game4 extends Scene {

    constructor() {
        super({ key: "Game4" });
    }
    init(data) {
        characterSelected = data.characterSelected;
        lastCoordenates = data.lastCoordenates;
        hasLightstick = false;
        speedEnemy = 100;
        redHeartsObject = [];
        blackHeartsObject = [];
        hearts = 2;
        this.startAll = false;
        this.firstStep = true;
        this.isInRedRoom = false;
        this.count = 0;
        this.events.off('buttonNext-dialogModal');
        setLastMovement('down')

    }

    preload() {
        if (this.sys.game.device.os.desktop) {
            console.log("desktop")
            this.isMobile = false;
        }
        else {
            this.isMobile = true;

            console.log("mobile")
        }
        cursors = this.input.keyboard.createCursorKeys();
    }

    create() {

        this.spaceBar = this.input.keyboard.addKey(Input.Keyboard.KeyCodes.SPACE);
        this.pauseButton = this.input.keyboard.addKey(Input.Keyboard.KeyCodes.P);
        this.dialogModal = this.plugins.get('dialogModal');

        gameSettings = localStorage.getItem('sound');
        if (gameSettings === null) {
            localStorage.setItem('sound', 1);
            gameSettings = defaultSettings;
        }

        this.events.on('pause', () => {
            if(this.joystickManager) {
                this.joystickManager.pause();
            }
            this.startAll = false;
        });

        this.events.on(`resume`, (data, args) => {
            this.sound.mute = false;
            if (args) {
                footsteps.stop();
                this.ppalSong.stop();
                this.scene.stop();
                if (args.goHome) {

                    if(this.joystickManager) {
                        this.joystickManager.destroyTest();
                        this.joystickManager = null;
                    }
                    this.events.off('buttonNext-dialogModal');

                    this.scene.start(`Hallway`, { characterSelected: characterSelected, loadAgain: true, lastCoordenates });
                }

                if (args.goStart) {

                    if(this.joystickManager) {
                        this.joystickManager.destroyTest();
                        this.joystickManager = null;
                    }
                    this.events.off('buttonNext-dialogModal');

                    this.scene.start(`Start`);
                }
            } else {

                if(!this.showingInstruction) {
                    this.startAll = true;
                }

                if(this.isMobile) {
                    if(this.joystickManager) {
                        this.joystickManager.show();
                    }
                }

                gameSettings = localStorage.getItem('sound');
                if (gameSettings === '0') {
                    if (this.ppalSong.isPlaying) {
                        this.ppalSong.stop()
                    }
                } else {
                    if (!this.ppalSong.isPlaying) {
                        this.ppalSong.play();
                    }
                }
            }
        });

        this.cameras.main.setBounds(0, 0, 3801);
        this.physics.world.setBounds(0, 0, 3801);

        this.ppalSong = this.sound.add(`youAndISong`, { loop: true, volume: 0.2 });
        if (gameSettings === '1') {
            this.ppalSong.play();
        }
        this.map = mapHandler(this, 'game4', true, 8, 8);

        footsteps = this.sound.add(`footsteps`, { loop: true, rate: 2 });

        this.playing = false;
        walls = this.map.walls;
        walls.setScale(3);
        this.map.ground.setScale(3);
        this.door = this.map.map.createLayer('Door', this.map.tileset, 0, 0);
        this.door.setCollisionByProperty({ collides: true });
        this.door.setScale(3);

        this.exit = this.map.map.createLayer('Exit', this.map.tileset, 0, 0);
        this.exit.setCollisionByProperty({ collides: true });
        this.exit.setScale(3);

        this.redRoom = this.map.map.createLayer('RedRoom', this.map.tileset, 0, 0);
        this.redRoom.setCollisionByProperty({ collides: true });
        this.redRoom.setScale(3);

        this.lightstick = this.map.map.createLayer('Lightstick', this.map.tileset, 0, 0);
        this.lightstick.setScale(3);
        this.lightstick.visible = false;

        this.object = this.map.map.createLayer('Objects', this.map.tileset, 0, 0);
        this.object.setCollisionByProperty({ collides: true });

        this.object.setScale(3);

        objNames[characterSelected] = this.physics.add.sprite(667, 2264, `${characterSelected}-game4`, 4);
        objNames[characterSelected].setScale(2.5);
        objNames[characterSelected].setImmovable();

        const itemRandom = randomPointsEnemy[Math.floor(Math.random() * randomPointsEnemy.length)];

        // let itemRandom2 = randomPointsEnemy[Math.floor(Math.random() * randomPointsEnemy.length)];

        // while (itemRandom2 === itemRandom) {
        //     itemRandom2 = randomPointsEnemy[Math.floor(Math.random() * randomPointsEnemy.length)];

        // }

        

        enemy1 = this.physics.add.sprite(itemRandom.x, itemRandom.y, `enemy1-game4`);
        enemy2 = this.physics.add.sprite(objNames[characterSelected].x + 30, objNames[characterSelected].y + 50, `enemy2-game4`).setActive(false).setVisible(false);
        enemy1.setImmovable();
        enemy2.setImmovable();
        enemy1.setScale(2.5);
        enemy2.setScale(2);

        walkAnimation(this, `${characterSelected}-game4`);
        reposeAnimation(this, `${characterSelected}-game4`);
        turnStaticAnimation(this, `${characterSelected}-game4`);
        upStaticAnimation(this, `${characterSelected}-game4`);
        leftStaticAnimation(this, `${characterSelected}-game4`);
        rightStaticAnimation(this, `${characterSelected}-game4`);
        backStaticAnimation(this, `${characterSelected}-game4`);
        lightstickAnimation(this, `${characterSelected}-game4`);

        walkAnimation(this, `enemy1-game4`);
        turnStaticAnimation(this, `enemy1-game4`);
        upStaticAnimation(this, `enemy1-game4`);
        leftStaticAnimation(this, `enemy1-game4`);
        rightStaticAnimation(this, `enemy1-game4`);
        backStaticAnimation(this, `enemy1-game4`);

        walkAnimation(this, `enemy2-game4`, true);
        turnStaticAnimation(this, `enemy2-game4`, 1);
        upStaticAnimation(this, `enemy2-game4`, 10);
        leftStaticAnimation(this, `enemy2-game4`, 4);
        rightStaticAnimation(this, `enemy2-game4`, 7);
        backStaticAnimation(this, `enemy2-game4`, 11);

        this.deadSprite = this.physics.add.sprite(0, 0, `humo-game4`).setScale(2).setVisible(false);
        this.anims.create({
            key: `deadSpriteAnimation`,
            frames: this.anims.generateFrameNumbers('humo-game4', { start: 0, end: 17 }),
            frameRate: 8,
            repeat: -1
        });


        this.physics.add.collider(objNames[characterSelected], walls);
        this.physics.add.collider(enemy1, walls, () => {
            randomDirection(`enemy1-game4`);
        }, null, this);
        this.physics.add.collider(enemy1, this.object, () => {
            randomDirection(`enemy1-game4`);
        }, null, this);
        this.physics.add.collider(enemy2, walls, () => {
            randomDirection(`enemy2-game4`);
        }, null, this);
        this.physics.add.collider(enemy2, this.object, () => {
            randomDirection(`enemy2-game4`);
        }, null, this);
        this.physics.add.collider(enemy1, objNames[characterSelected], () => {

            objNames[characterSelected].anims.play(`repose-${characterSelected}-game4`);

            this.startAll = false;
            
            enemy1.active = false;
            enemy1.setVelocity(0, 0);
            this.deadSprite.setPosition(enemy1.x, enemy1.y);
            this.deadSprite.visible = true;
            this.deadSprite.anims.play(`deadSpriteAnimation`, true);
            objNames[characterSelected].setVelocity(0, 0);
            objNames[characterSelected].anims.play(`repose-${characterSelected}-game4`);
            enemy1.destroy();

            this.timeoutLady = setTimeout(() => {
            this.deadSprite.visible = false;
            this.showingInstruction = true;
            this.dialogModal._createImageDialog(this, 'third-text');
            
            this.dialogModal.setText("The woman just disappeared! \nI completely forgot that I'm trapped in a nightmare... \nAnything can happen here, \nI have to find my lightstick to be able to wake up.".toUpperCase(), `${characterSelected}-hallway`, false, false);
            this.speedEnemy = 50;

            }, 2000);

        }, null, this);


        this.physics.add.collider(enemy2, objNames[characterSelected], () => {
            if (enemy2.active) {

                enemy2.active = false;
                objNames[characterSelected].alpha = 0.5;
                objNames[characterSelected].setTint(0xff0000);
                objNames[characterSelected].setVelocity(0, 0);
                objNames[characterSelected].anims.play(`repose-${characterSelected}-game4`);
                this.deadSprite.setPosition(objNames[characterSelected].x, objNames[characterSelected].y);
                this.deadSprite.visible = true;
                this.deadSprite.anims.play(`deadSpriteAnimation`, true);
                this.startAll = false;

                clearTimeout(this.timeoutColliderEnemy);
                this.timeoutColliderEnemy = setTimeout(() => {

                    this.tweens.add({
                        targets: redHeartsObject[hearts - 1],
                        alpha: 0,
                        scaleX: 0,
                        scaleY: 0,
                        ease: 'Linear',
                        duration: 200
                    });

                    var heartsTimeline = this.tweens.createTimeline();

                    heartsTimeline.add({
                        targets: blackHeartsObject[hearts - 1],
                        scaleX: 1.5,
                        scaleY: 1.5,
                        ease: 'Power1',
                        duration: 200
                    });


                    heartsTimeline.add({
                        targets: blackHeartsObject[hearts - 1],
                        scaleX: 3,
                        scaleY: 3,
                        ease: 'Power1',
                        duration: 200
                    });
                    heartsTimeline.play();
                    hearts -= 1;
                    setTimeout(() => {
                        if (hearts <= 0) {
                            if(this.joystickManager) {
                                this.joystickManager.destroyTest();
                            }
                            enemy2.destroy();
                            this.cameras.main.fade(1000, 0, 0, 0, false, (cam, progress) => {
                                if (progress === 1) {
                                    footsteps.stop();
                                    this.ppalSong.stop();
                                    this.scene.stop();
                                    this.events.off('buttonNext-dialogModal');
                                    this.scene.start(`GameOver`, { characterSelected: characterSelected, level: 4, lastCoordenates });
                                }
                            });
                        } else {
                            this.startAll = true;
                            this.deadSprite.visible = false;
                            // enemy2.active = true;
                            // let itemRandom3 = randomPointsEnemy[Math.floor(Math.random() * randomPointsEnemy.length)];

                            // while (itemRandom3 === itemRandom2) {
                            //     itemRandom3 = randomPointsEnemy[Math.floor(Math.random() * randomPointsEnemy.length)];

                            // }

                            // enemy2.setPosition(objNames[characterSelected].x, objNames[characterSelected].y);

                            setTimeout(() => {
                                enemy2.active = true;

                            }, 1000);
                        }


                        objNames[characterSelected].clearTint();
                        objNames[characterSelected].alpha = 1;

                    }, 1000);

                }, 500);

            }

        }, null, this);

        this.physics.add.collider(objNames[characterSelected], this.object);
        this.physics.add.collider(enemy1, this.object);
        this.physics.add.collider(enemy2, this.object);
        this.physics.add.collider(objNames[characterSelected], this.door, () => {

            this.textHoldOn.setPosition(this.screenCenterX, this.screenCenterY + 15);
            this.textHoldOn.visible = true;

            clearTimeout(timeoutDoor);
            timeoutDoor = setTimeout(() => {

                this.cameras.main.fade(1000, 0, 0, 0, false, (cam, progress) => {
                    if (progress === 1) {
                        this.cameras.main.fadeIn();

                        this.startAll = false;
                        this.showingInstruction = true;
                        this.textHoldOn.visible = false;
                        this.dialogModal._createImageDialog(this, 'second-text');

                        this.dialogModal.setText("Why is there a circle on the floor? \nI can see a woman in the next room, \nmaybe she can tell me what this place is and why I'm here...".toUpperCase(), `${characterSelected}-hallway`, false, false);
                        objNames[characterSelected].setPosition(2190, 1950);
                    }
                });

            }, 1000);
        }, null, this);

        this.physics.add.overlap(objNames[characterSelected], this.redRoom, function onOverlap() {
            objNames[characterSelected].setTint(0xff0000);

            clearTimeout(this.timeoutRedRoom);
            this.timeoutRedRoom = setTimeout(() => {
                objNames[characterSelected].clearTint();
            }, 100);
        },
            function process(sprite, tile) {
                return tile.collides;
            }
        );

        this.physics.add.overlap(objNames[characterSelected], this.exit, function onOverlap() {
            if(this.startAll) {
                this.count++;
    
                this.textHoldOn.visible = true;
                
                if (hasLightstick && enemy2.active) {
                    enemy2.active = false;
                    enemy2.visible = false;
                }
                if(hasLightstick) {
                    this.textHoldOn.setText('hold on . . .'.toUpperCase());
                    this.textHoldOn.setPosition(this.screenCenterX, this.screenCenterY + 15);
                } else {
                    this.textHoldOn.setText('hold on if you want to go to the hallway.'.toUpperCase());
                    this.textHoldOn.setPosition(this.screenCenterX + 70, this.screenCenterY + 15);
                }
                
                if (hasLightstick && this.count > 2000) {

                    this.count = 0;
                    let total = JSON.parse(localStorage.getItem('noL'));
                    if (total) {
                        if (!total.includes(4)) {
                            total.push(4);
                            localStorage.setItem('noL', JSON.stringify(total));
                            
                        }
                    } else {
                        localStorage.setItem('noL', JSON.stringify([4]));
                    }
                    
                    this.cameras.main.fade(1000, 0, 0, 0, false, (cam, progress) => {
                        if (progress === 1) {
                            footsteps.stop();
                            this.ppalSong.stop();
                            this.scene.stop();
                            this.textHoldOn.visible = false;
                            if(this.joystickManager) {
                                this.joystickManager.destroyTest();
                                this.joystickManager = null;
                            }
                            this.events.off('buttonNext-dialogModal');
                            
                            this.scene.start(`Win`, { characterSelected: characterSelected, level: 4, lastCoordenates });
                        }
                    });
                    
                } else {

                    if (this.count > 10000) {
                        this.cameras.main.fade(1000, 0, 0, 0, false, (cam, progress) => {
                            if (progress === 1) {
                                footsteps.stop();
                                this.ppalSong.stop();
                                this.scene.stop();
                                this.textHoldOn.visible = false;
                                if(this.joystickManager) {
                                    this.joystickManager.destroyTest();
                                    this.joystickManager = null;
                                }
                                this.events.off('buttonNext-dialogModal');
    
                                this.scene.start(`Hallway`, { characterSelected: characterSelected, loadAgain: true });
                            }
                        });
                    }
    
                }
    
    
                clearTimeout(this.timeoutPortal);
                this.timeoutPortal = setTimeout(() => {
                    this.count = 0;
                    this.textHoldOn.visible = false;
    
                }, 1000);

            }
        }.bind(this),
            function process(sprite, tile) {
                return tile.collides;
            }
        );

        this.physics.add.overlap(enemy1, this.redRoom, function onOverlap() {
            enemy1.setTint(0xff0000);

            clearTimeout(this.timeoutRedRoomenemy);
            this.timeoutRedRoomenemy = setTimeout(() => {
                enemy1.clearTint();
            }, 100);
        },
            function process(sprite, tile) {
                return tile.collides;
            }
        );

        this.physics.add.overlap(enemy2, this.redRoom, function onOverlap() {
            enemy2.setTint(0xff0000);

            clearTimeout(this.timeoutRedRoomenemy);
            this.timeoutRedRoomenemy = setTimeout(() => {
                enemy2.clearTint();
            }, 100);
        },
            function process(sprite, tile) {
                return tile.collides;
            }
        );

        this.time.addEvent({
            delay: 3000,
            callback: () => {
                randomDirection(`enemy1-game4`);
                randomDirection(`enemy2-game4`);
            },
            loop: true
        })

        this.time.addEvent({
            delay: 10000,
            callback: () => {
                if (enemy2.active && speedEnemy < 300) {
                    speedEnemy += 20;
                }
            },
            loop: true
        })

        this.cameras.main.startFollow(objNames[characterSelected], true);

        this.buttonFullscreen = new FullScreen(this);
        this.buttonSettings = new SettingsButton(this);
        this.buttonPause = new PauseButton(this, characterSelected);
        this.buttonHelp = new HelpButton(this);


        window.addEventListener("blur", () => {
            this.buttonPause.pauseByEvent();
         });
     
        //  document.addEventListener('visibilitychange', () => {
        //      if (document.visibilityState !== 'visible') {
        //          this.buttonPause.pauseByEvent();
        //  } 
        //  });

        this.events.on('buttonNext-dialogModal', (data) => {
            instructionsHandler++;
            if (data.id === 'start-text') {
                if (instructionsHandler === 1) {
                    this.dialogModal.close();
                    instructionsHandler = 0;
                    this.startAll = true;
                    this.showingInstruction = false;

                    if(this.isMobile) {
                        this.joystickManager = new Joystick(objNames[characterSelected], `${characterSelected}-game4`, 300);
                        this.joystickManager.createJoystick();
                        this.joystickManager.activate(hasLightstick);

                    }

                }
            }

            if (data.id === 'second-text') {
                if (instructionsHandler === 1) {
                    this.dialogModal.close();
                    instructionsHandler = 0;
                    this.startAll = true;
                    this.showingInstruction = false;

                }
            }

            if (data.id === 'third-text') {
                if (instructionsHandler === 1) {
                    this.dialogModal.close();
                    instructionsHandler = 0;
                    this.startAll = true;
                    this.showingInstruction = false;

                    setTimeout(() => {
                        this.startAll = false;
                        this.showingInstruction = true;

                        objNames[characterSelected].setVelocity(0, 0);
                        objNames[characterSelected].anims.play(`repose-${characterSelected}-game4`);
                        this.dialogModal._createImageDialog(this, 'fourth-text');

                        this.dialogModal.setText("Did the woman turn into the spider? \nI have to find my lightstick and make sure \nthe spider doesn't harm me. \nI have to hurry...".toUpperCase(), `${characterSelected}-hallway`, false , false);
                        // setTimeout(() => {
                        //     setTimeout(() => {
                        //         this.lightstick.visible = true;
                        //         enemy2.visible = true;
                        //         enemy2.setPosition(objNames[characterSelected].x, objNames[characterSelected].y);
                                
                        //         setTimeout(() => {
                        //             enemy2.active = true;
                        //         }, 1000)

                        //     }, 2000);
                        // }, 1000);
                    }, 3000);
                }
            }

            if (data.id === 'fourth-text') {
                if (instructionsHandler === 1) {
                    this.dialogModal.close();
                    instructionsHandler = 0;
                    this.startAll = true;
                    this.showingInstruction = false;

                    setTimeout(() => {
                        this.lightstick.visible = true;
                        enemy2.setPosition(objNames[characterSelected].x, objNames[characterSelected].y);

                        this.deadSprite.setPosition(enemy2.x, enemy2.y);
                        this.deadSprite.visible = true;
                        this.deadSprite.anims.play(`deadSpriteAnimation`, true);

                        setTimeout(() => {
                            enemy2.visible = true;
                            enemy2.active = true;
                            this.deadSprite.visible = false;
                        }, 1000)

                    }, 2000);

                }
            }

            if (data.id === 'fifth-text') {
                if (instructionsHandler === 1) {
                    this.dialogModal.close();
                    instructionsHandler = 0;
                    this.startAll = true;
                    this.showingInstruction = false;

                }
            }
        })



        objNames[characterSelected].anims.play(`repose-${characterSelected}-game4`);
        this.showingInstruction = true;
        this.dialogModal._createImageDialog(this, 'start-text');
        
        this.dialogModal.setText("Where am I? \nThere's no one around. \nI think I have to cross through that portal to find some answers....".toUpperCase(), `${characterSelected}-hallway`, false, false);
        setTimeout(() => {
            this.dialogPpalVisible = true;
        }, 1000);

        if (this.isMobile) {
            this.buttonAction = new ButtonPressed(this, 700, 500 - 51, `buttonAction`);
            this.buttonAction.setScale(2);
            this.add.existing(this.buttonAction);
        }

        let x = 0;
        let y = 16;
        for (let i = 0; i < totalHearts; i++) {
            if (i === 0) {
                x += 40;
            } else {
                x += 30;
            }
            blackHeartsObject.push(this.add.image(x, y, `heartBlack`, 0).setScale(3).setOrigin(1, 0).setScrollFactor(0));
            redHeartsObject.push(this.add.image(x, y, `heartRed`, 0).setScale(3).setOrigin(1, 0).setScrollFactor(0));
        }

        this.lightstickCounter = new LightstickCounter(this);
        this.helpLightstick = this.add.bitmapText(0, 20, 
            'pixelfont', "Interact: spacebar/action button".toUpperCase(), 10,1).setTint(0xffffff).setOrigin(1, 0).setScale(1).setVisible(false).setScrollFactor(0);
        this.textHoldOn = this.add.bitmapText(0, 20, 
            'pixelfont', "Hold On . . .".toUpperCase(), 10,1).setTint(0xffffff).setOrigin(1, 0).setScale(1).setVisible(false).setScrollFactor(0);

        this.screenCenterX = (this.cameras.main.worldView.x + this.cameras.main.width / 2) + 50;
        this.screenCenterY = this.cameras.main.worldView.y;
    }


    update() {


        if (this.startAll) {
            if (!this.isMobile) {
                walkHandler(cursors, objNames[characterSelected], 300, `${characterSelected}-game4`, hasLightstick);
            } else {
                if(this.joystickManager) {
                    this.joystickManager.show();
                }
            }

            if ((!this.isMobile && (cursors.left.isDown || cursors.right.isDown || cursors.up.isDown || cursors.down.isDown))) {
                if (this.playing !== true) {
                    if (gameSettings === '1') {

                        footsteps.play();
                        this.playing = true;
                    }
                }
                // else {
                //     this.playing = false;
                //     footsteps.stop();
                // }

            } else {
                this.playing = false;
                footsteps.stop();
            }

            if (enemy1.active) {
                directionHandler(enemy1, speedEnemy, `enemy1-game4`);

            }

            if (enemy2.active) {
                const angles = MathPhaser.Angle.BetweenPoints(enemy2, objNames[characterSelected])
                const newAngles = MathPhaser.RadToDeg(angles);

                if (enemy2.body.speed > 0) {
                    if (newAngles <= -45 && newAngles >= -135) {
                        enemy2.anims.play(`up-enemy2-game4`, true);
                    } else if (newAngles <= 45 && newAngles >= -45) {
                        enemy2.flipX = true
                        enemy2.anims.play(`left-enemy2-game4`, true);
                    } else if (newAngles <= 135 && newAngles >= 45) {
                        enemy2.anims.play(`down-enemy2-game4`, true);
                    } else if (newAngles <= 225 && newAngles >= 135) {
                        enemy2.flipX = true
                        enemy2.anims.play(`right-enemy2-game4`, true);
                    }

                }
                this._enemyFollows();
            }

        } else {
            if(this.isMobile) {
                if(this.joystickManager) {
                    objNames[characterSelected].setVelocity(0, 0);
                    objNames[characterSelected].anims.play(`repose-${characterSelected}-game4`);
                    this.joystickManager.pause();
                }
            }
        }

        // if (!this.isMobile && this.pauseButton.isDown) {

        //     this.scene.launch('Pause', { scene: 'Game4' });
        //     this.scene.pause();

        // }

        const tile = this.lightstick.getTileAtWorldXY(objNames[characterSelected].x, objNames[characterSelected].y);
        if (tile) {
            if (this.lightstick.visible) {
                this.helpLightstick.setPosition(this.screenCenterX + 50, this.screenCenterY + 15);
                this.helpLightstick.visible = true;
                if ((!this.isMobile && this.spaceBar.isDown) || (this.isMobile && this.buttonAction.isDown)) {
                    this.lightstick.visible = false;
                    hasLightstick = true;
                    if(this.isMobile) {
                        this.joystickManager.setLightStickValue(hasLightstick);
                    }
                    this.startAll = false;
                    this.showingInstruction = true;
                    objNames[characterSelected].setVelocity(0, 0);
                    objNames[characterSelected].anims.play(`repose-${characterSelected}-game4`);
                    // this.dialogModal._createWindow(this, 'fifth-text', null, true);
                    this.dialogModal._createImageDialog(this, 'fifth-text');
                    this.dialogModal.setText("Great! I found it! \nNow I have to escape from here. \nI need to go back to the circle on the floor in the main room, \nbut I have to be careful with the spider.", 
                        `${characterSelected}-hallway`, false, false)
                    setTimeout(() => {
                        this.dialogLightstickVisible = true;
                        this.firstStep = false;
                    }, 1000);
                }
            }

        } else {
            this.helpLightstick.visible = false;
        }
    }

    _enemyFollows() {
        this.physics.moveToObject(enemy2, objNames[characterSelected], speedEnemy);
    }


}